export enum LocalStorageKey {
  CookieConsent = 'cookie-consent'
}
